import { render, staticRenderFns } from "./InputKasMutasi.vue?vue&type=template&id=56989ba3&"
import script from "./InputKasMutasi.vue?vue&type=script&lang=js&"
export * from "./InputKasMutasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports